import { FeatureFlag } from '../FeatureFlag';

export const enableThemeSwitching = new FeatureFlag({
    key: 'enable-theme-switching',
    defaultValue: false,
});
